import React from 'react';
import {connect} from 'react-redux';
import ThankYouTick from '../_styles/images/thankyou-tick.svg'
import analyticsService from '../shared/analytics/analytics-service';
import * as actionTypes from '../redux/actionTypes';



function InviteThankYou(props) {

  function goToDashboard() {
    analyticsService.analyticsProcessEvent({
      "event": "click_generic",
      "context": {
        "event_action": "go to dashboard"
      }
    });
    props.resetInviteSuccess();
    props.history.push("/dashboard");
  }

  return (
    <div className='invite-thank-you-page'>
      <div className='invite-thank-you-container'>
        <div className='invite-content-container'>
          <div className='left-container'>
            <div className='heading-container'>
              <img className='tick' src={ThankYouTick} alt="tick" />
              <div className='heading'>Your invitation(s) have been sent!</div>
            </div>
            <div className='comment'><span>Please Note:  </span> the people you invited won't be added automatically. They will need to join the vanpool by clicking the link in their email.</div>
            <button onClick={goToDashboard}>Done</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    resetInviteSuccess() {
      dispatch({
        type: actionTypes.INVITE_RIDER_SUCCESS,
        data: null
      });
    }
  };
}

export default connect(null, mapDispatchToProps)(InviteThankYou);